import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function DerechoDeRetracto() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>X. DERECHO DE RETRACTO</h4>
          <br></br>
          <p>
            De acuerdo con el artículo 47 del Estatuto del Consumidor, el derecho de retracto permite al Usuario desistir de un contrato celebrado a distancia, como sucede con los servicios adquiridos a través de nuestra las Plataformas. Este derecho es aplicable siempre que el servicio o bien adquirido no haya comenzado a ser consumido o disfrutado.
          </p>
          <p>
            En Parking, este derecho se reconoce para aquellos servicios cuya ejecución no se inicia de manera inmediata tras el pago. En estos casos, el Usuario podrá ejercer su derecho de retracto dentro de los cinco (5) días hábiles siguientes a la fecha de la transacción. Para ello, deberá manifestar su intención enviando una solicitud al correo electrónico <a href="mailto:servicioalcliente@parking.net.co">servicioalcliente@parking.net.co</a>. Los servicios para los cuales aplica el derecho de retracto son: pasadía, reservas.
          </p>
          <p>
            Es importante tener en cuenta que algunos de nuestros servicios, por su naturaleza, comienzan a prestarse desde el momento del pago o activación. Por ejemplo, el servicio de mensualidad se considera disfrutado desde su contratación. En tales casos, el derecho de retracto no aplica, conforme a las excepciones establecidas por la normativa.
          </p>
          <p>
            Cuando el derecho de retracto sea válido y se ejerza, esto generará la resolución del contrato, lo que implica la devolución mutua de las prestaciones. Parking reembolsará el monto pagado por el Usuario en un plazo máximo de quince (15) días calendario contados a partir de la recepción de la solicitud de retracto.
          </p>
        </Col>
      </Row>
    </Container>
  );
}